import { render, staticRenderFns } from "./starshop-routing-setting.vue?vue&type=template&id=d13d4da8&scoped=true"
import script from "./starshop-routing-setting.vue?vue&type=script&lang=js"
export * from "./starshop-routing-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13d4da8",
  null
  
)

export default component.exports